module.exports = __webpack_public_path__ + "img/back pocket flap width.d6de6b7e.png";